import dayjs from "dayjs";

const TIME_UNIT_ABBREVIATIONS = {
  second: "s",
  minute: "m",
  hour: "h",
  day: "d",
  week: "w",
  month: "M",
  year: "y",
};

function fromNow(createdTime, useAbbreviatedUnitTime = false) {
  const now = new Date();
  const past = new Date(createdTime);
  const diffInSeconds = Math.floor((now - past) / 1000);

  const isFuture = diffInSeconds < 0;
  const absoluteDiffInSeconds = Math.abs(diffInSeconds);
  const constructUnitOfTime = (diffInTime, unitOfTime) => {
    let unitOfTimeString = diffInTime.toString();
    if (useAbbreviatedUnitTime) {
      unitOfTimeString += TIME_UNIT_ABBREVIATIONS[unitOfTime];
    } else {
      unitOfTimeString += `${unitOfTime}${diffInTime === 1 ? "" : "s"}`;
    }
    unitOfTimeString += `${isFuture ? "" : " ago"}`;
    return unitOfTimeString;
  }

  if (absoluteDiffInSeconds < 60) return constructUnitOfTime(absoluteDiffInSeconds, "second");
  const diffInMinutes = Math.floor(absoluteDiffInSeconds / 60);
  if (diffInMinutes < 60) return constructUnitOfTime(diffInMinutes, "minute");
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return constructUnitOfTime(diffInHours, "hour");
  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) return constructUnitOfTime(diffInDays, "day");
  const diffInWeeks = Math.floor(diffInDays / 7);
  if (diffInWeeks < 4) return constructUnitOfTime(diffInWeeks, "week");
  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12) return constructUnitOfTime(diffInMonths, "month");
  const diffInYears = Math.floor(diffInDays / 365);
  return constructUnitOfTime(diffInYears, "year");
}

function checkGivenDateIsAfterCurrentDate(date) {
  return dayjs(date).isAfter(dayjs(), "minutes");
}

function getMomentDate(targetDate) {
  return dayjs(new Date(targetDate));
}

function getHSFormattedDateString(targetDate) {
  return dayjs(targetDate).format("DD MMM, YYYY hh:mm");
}

const getIsoFormattedDateAndTime = (date, time) => {
  const dateAndTimeStringInLocal = dayjs(date).format("YYYY-MM-DD") + "T" + time.format("HH:mm:ss");
  const dateObj = new Date(dateAndTimeStringInLocal);
  return dateObj.toISOString();
};

export { checkGivenDateIsAfterCurrentDate, getHSFormattedDateString, getIsoFormattedDateAndTime, getMomentDate, fromNow };
